let filters = {};

filters.secondaryDateRangePlaceholder = 'Compare Date Range';

filters.products = [
  {
    display_value: 'Auto',
    internal_value: 1,
    visible: true,
    display_order: 0,
    product_class: 'auto_filter_css',
  },
  {
    display_value: 'Home',
    internal_value: 21,
    visible: true,
    display_order: 0,
    product_class: 'home_filter_css',
  },
  {
    display_value: 'Condo',
    internal_value: 18,
    visible: true,
    display_order: 0,
    product_class: 'condo_filter_css',
  },
  {
    display_value: 'Renters',
    internal_value: 12,
    visible: true,
    display_order: 0,
    product_class: 'renters_filter_css',
  },
  {
    display_value: 'Home + Auto',
    internal_value: '1_21',
    visible: true,
    display_order: 0,
    product_class: 'home_auto_filter_css',
  },
  {
    display_value: 'Condo + Auto',
    internal_value: '1_18',
    visible: true,
    display_order: 0,
    product_class: 'auto_condo_filter_css',
  },
  {
    display_value: 'Renters + Auto',
    internal_value: '1_12',
    visible: true,
    display_order: 0,
    product_class: 'auto_renter_filter_css',
  },
];

filters.products_with_icons = [
  {
    display_value: '<i class="qrp-icon-font">&#xf1b9;</i> Auto',
    internal_value: 1,
    visible: true,
    display_order: 0,
    product_class: 'auto_filter_css',
  },
  {
    display_value: '<i class="qrp-icon-font">&#xf015;</i> Home',
    internal_value: 21,
    visible: true,
    display_order: 0,
    product_class: 'home_filter_css',
  },
  {
    display_value: '<i class="qrp-icon-font">&#xf594;</i> Condo',
    internal_value: 18,
    visible: true,
    display_order: 0,
    product_class: 'condo_filter_css',
  },
  {
    display_value: '<i class="qrp-icon-font">&#xf1ad;</i> Renters',
    internal_value: 12,
    visible: true,
    display_order: 0,
    product_class: 'renter_filter_css',
  },
  {
    display_value: '<i class="qrp-icon-font">&#xf015;&nbsp;&#xf1b9;</i> Home + Auto',
    internal_value: '1_21',
    visible: true,
    display_order: 0,
    product_class: 'home_auto_filter_css',
  },
  {
    display_value: '<i class="qrp-icon-font">&#xf594;&nbsp;&#xf1b9;</i> Condo + Auto',
    internal_value: '1_18',
    visible: true,
    display_order: 0,
    product_class: 'auto_condo_filter_css',
  },
  {
    display_value: '<i class="qrp-icon-font">&#xf1ad;&nbsp;&#xf1b9;</i> Renters + Auto',
    internal_value: '1_12',
    visible: true,
    display_order: 0,
    product_class: 'auto_renter_filter_css',
  },
];

filters.search_products_with_icons = {
  1: {
    display_value: 'Auto',
    internal_value: 1,
    custome_set: 'auto',
    icon: 'fa-car',
    class: 'auto-blue-box',
    active_class: 'auto-blue-active',
  },
  21: {
    display_value: 'Home',
    internal_value: 21,
    custome_set: 'home',
    icon: 'fa-home',
    class: 'home-green-box',
    active_class: 'home-green-active',
  },
  18: {
    display_value: 'Condo',
    internal_value: 18,
    custome_set: 'condo',
    icon: 'fa-hotel',
    class: 'condo-purple-box',
    active_class: 'condo-purple-active',
  },
  12: {
    display_value: 'Renters',
    internal_value: 12,
    custome_set: 'apartment',
    icon: 'fa-building',
    class: 'renter-lg-box',
    active_class: 'renter-lg-active',
  },
  '1_21': {
    display_value: 'Home + Auto Bundle',
    internal_value: '1_21',
    custome_set: 'home-auto-bundle',
    icon: 'fa-home-auto-bundle',
    class: 'home-auto-bundle-lg-box',
    active_class: 'home-auto-bundle-lg-active',
  },
  '1_18': {
    display_value: 'Condo + Auto Bundle',
    internal_value: '1_18',
    custome_set: 'condo-auto-bundle',
    icon: 'fa-condo-auto-bundle',
    class: 'condo-auto-bundle-lg-box',
    active_class: 'condo-auto-bundle-lg-active',
  },
  '1_12': {
    display_value: 'Renters + Auto Bundle',
    internal_value: '1_12',
    custome_set: 'renter-auto-bundle',
    icon: 'fa-renter-auto-bundle',
    class: 'renter-auto-bundle-lg-box',
    active_class: 'renter-auto-bundle-lg-active',
  },
};


filters.search_products_with_icons_multiselect = {
  1: {
    display_value: 'Auto',
    internal_value: '1',
    custome_set: 'auto',
    icon: 'fa-car',
    class: 'auto-blue-box',
    active_class: 'auto-blue-active',
  },
  21: {
    display_value: 'Home',
    internal_value: '21',
    custome_set: 'home',
    icon: 'fa-home',
    class: 'home-green-box',
    active_class: 'home-green-active',
  },
  18: {
    display_value: 'Condo',
    internal_value: '18',
    custome_set: 'condo',
    icon: 'fa-hotel',
    class: 'condo-purple-box',
    active_class: 'condo-purple-active',
  },
  12: {
    display_value: 'Renters',
    internal_value: '12',
    custome_set: 'apartment',
    icon: 'fa-building',
    class: 'renter-lg-box',
    active_class: 'renter-lg-active',
  },
  '1_21': {
    display_value: 'Home + Auto Bundle',
    internal_value: '1_21',
    custome_set: 'home-auto-bundle',
    icon: 'fa-home-auto-bundle',
    class: 'home-auto-bundle-lg-box',
    active_class: 'home-auto-bundle-lg-active',
  },
  '1_18': {
    display_value: 'Condo + Auto Bundle',
    internal_value: '1_18',
    custome_set: 'condo-auto-bundle',
    icon: 'fa-condo-auto-bundle',
    class: 'condo-auto-bundle-lg-box',
    active_class: 'condo-auto-bundle-lg-active',
  },
  '1_12': {
    display_value: 'Renters + Auto Bundle',
    internal_value: '1_12',
    custome_set: 'renter-auto-bundle',
    icon: 'fa-renter-auto-bundle',
    class: 'renter-auto-bundle-lg-box',
    active_class: 'renter-auto-bundle-lg-active',
  },
};

filters.dateRange = [
  {
    display_value: 'Today',
    internal_value: 'Today',
    visible: true,
    display_order: 0,
    comparison_value: 'Yesterday',
  },
  {
    display_value: 'Yesterday',
    internal_value: 'Yesterday',
    visible: true,
    display_order: 0,
    comparison_value: 'Today',
  },
  {
    display_value: 'Current Week',
    internal_value: 'CurrentWeek',
    visible: true,
    display_order: 0,
    comparison_value: 'PreviousWeek',
  },
  {
    display_value: 'Previous Week',
    internal_value: 'PreviousWeek',
    visible: true,
    display_order: 0,
    comparison_value: 'CurrentWeek',
  },
  {
    display_value: 'Current Month',
    internal_value: 'CurrentMonth',
    visible: true,
    display_order: 0,
    comparison_value: 'PreviousMonth',
  },
  {
    display_value: 'Previous Month',
    internal_value: 'PreviousMonth',
    visible: true,
    display_order: 0,
    comparison_value: 'CurrentMonth',
  },
];

filters.displayTypes = {
  'dateRange': 'date range',
  'policyTerm': 'policy term',
},

filters.policyTerm = [
  {
    display_value: '6 Month',
    internal_value: '6Month',
    visible: true,
    display_order: 0,
  },
  {
    display_value: '12 Month',
    internal_value: '12Month',
    visible: true,
    display_order: 0,
  },
];

filters.dateRangeMinimal = [
  {
    display_value: 'Today',
    internal_value: 'Today',
    visible: true,
    display_order: 0,
  },
  {
    display_value: 'Yesterday',
    internal_value: 'Yesterday',
    visible: true,
    display_order: 0,
  },
  {
    display_value: 'Current Month',
    internal_value: 'CurrentMonth',
    visible: true,
    display_order: 0,
  },
  {
    display_value: 'Previous Month',
    internal_value: 'PreviousMonth',
    visible: true,
    display_order: 0,
  },
];

filters.dateFilterDefaults = {
  dashboardWidgets: {
    stateDateFilters: 'Today',
    agentDateFilters: 'Today',
    carrierDateFilters: 'Today',
    carrierSalesDateFilters: 'Today',
    productSalesDateFilters: 'Today',
  },
  reports: {
    reportsDownloadDataFilters: 'PreviousMonth'
  }
};

filters.productDefault = 1;

filters.dimensions = [
  {
    display_value: 'Agent',
    internal_value: 'Agent',
    visible: true,
    display_order: 0,
  },
  {
    display_value: 'Carrier',
    internal_value: 'Carrier',
    visible: true,
    display_order: 0,
  },
  {
    display_value: 'State',
    internal_value: 'State',
    visible: true,
    display_order: 0,
  },
  // {
  //   display_value: 'Product',
  //   internal_value: 'Product',
  //   visible: true,
  //   display_order: 0,
  // },
];

filters.filters = {}; // TODO: Call API to populate

filters.filters.states = [
  {
    display_value: 'California',
    internal_value: 'ca',
    visible: false,
    display_order: 0,
  },
  {
    display_value: 'New Mexico',
    internal_value: 'nm',
    visible: false,
    display_order: 0,
  },
  {
    display_value: 'New York',
    internal_value: 'ny',
    visible: false,
    display_order: 0,
  },
  {
    display_value: 'Washington D.C.',
    internal_value: 'dc',
    visible: false,
    display_order: 0,
  },
];

filters.filters.carriers = [
  {
    display_value: 'Progressive',
    internal_value: '3',
    visible: false,
    display_order: 0,
  },
  {
    display_value: 'Good2Go Insurance',
    internal_value: '7',
    visible: false,
    display_order: 0,
  },
  {
    display_value: 'Dairyland',
    internal_value: '99',
    visible: false,
    display_order: 0,
  },
  {
    display_value: 'Future Insurance Co.',
    internal_value: '100',
    visible: false,
    display_order: 0,
  },
];

filters.filters.users = [
  {
    display_value: 'Agent Orange',
    internal_value: '1001',
    visible: false,
    display_order: 0,
  },
  {
    display_value: 'Blue Agent',
    internal_value: '1003',
    visible: false,
    display_order: 0,
  },
  {
    display_value: 'Agent, The Third',
    internal_value: '1005',
    visible: false,
    display_order: 0,
  },
  {
    display_value: '007 Agent',
    internal_value: '1009',
    visible: false,
    display_order: 0,
  },
];

filters.tableTootips = {
  'CarrierName': 'Carriers that have returned rates and errors within the selected date range.',
  'AgentFullName': '',
  'ProductName': 'Products that have returned rates within the selected date range.',
  'EventDate': 'Date Format MM/DD/YYYY',
  'StateTitleAbbrev': 'Quoted states within the  selected date range.',
  'CustomerCount':  'The number of quotes  completed within the selected  date range',
  'PolicyCount': 'The number of sold policies  within the selected date range.',
  'RateCallCount': 'The number of rate calls (RC1)  made within the selected date  range.',
  'AvgRateCallPremium': 'The average rate call (RC1) quoted premium amount within  the selected date range.',
  'AvgPolicyPremium': 'The average sold policy premium  amount within the selected date range.',
  'RateCallSuccess': 'The number of rate calls (RC1) that successfully returned rates within the selected date range.',
  'RateCallError': 'The number of failed rate calls(RC1) within the selected date range.',
};
filters.filters.agencies = [
  {
    display_value: 'Agency A',
    internal_value: '10',
    visible: false,
    display_order: 0,
  },
  {
    display_value: 'Agency B',
    internal_value: '11',
    visible: false,
    display_order: 0,
  },
  {
    display_value: 'Agency DCCC',
    internal_value: '12',
    visible: false,
    display_order: 0,
  },
  {
    display_value: 'Agency E',
    internal_value: '17',
    visible: false,
    display_order: 0,
  },
];

filters.columns = {};

// List of columns that have 'currency' values
filters.columns.currency = [
  'AvgPolicyPremium',
  'AvgRateCallPremium',
  'Premium',
  'MonthlyPayment',
];

filters.columns.numeric = [
  'CustomerCount',
  'PolicyCount',
  'RateCallCount',
  'RateCallSuccess',
  'RateCallError',
];

filters.columns.dates = [
  'EventDate',
];

filters.columns.terms = [
  'PolicyTerm',
];

filters.columns.phonenumbers = [
  'ClientPhone',
];

// TODO: importUsers comlumn values need a human-readable version
filters.columns.importUsers = [
  {
    key: 'discard',
    excludeFromDownload: true,
  },
  {
    key: 'firstName',
  },
  {
    key: 'middleInitial',
  },
  {
    key: 'lastName',
  },
  {
    key: 'email',
  },
  {
    key: 'phoneNumber',
  },
  {
    key: 'role',
  },
  {
    key: 'errorMessage',
    variant: 'danger', // Supports: active, success, info, warning, danger
    excludeFromDownload: true,
    excludeFromInitial: true,
  },
];

filters.columns.sortBy = 'CustomerCount'; // Sort by "Quotes"
filters.columns.sortDesc = true; // Sort in descending order?

filters.userRoles = {
  agent: {
    roleValue: 'Agent',
    roleText: 'Agent',
  },
  agencyadmin: {
    roleValue: 'AgencyAdmin',
    roleText: 'Agency Admin',
  },
  agencymanager: {
    roleValue: 'AgencyManager',
    roleText: 'Agency Manager',
  },
};
export default filters;


//////////////////
// WEBPACK FOOTER
// ./config/admin/filters.js
// module id = null
// module chunks = 